import { render } from "./recent_project_carousel.vue?vue&type=template&id=baaf64ea"
import script from "./recent_project_carousel.vue?vue&type=script&lang=js"
export * from "./recent_project_carousel.vue?vue&type=script&lang=js"

import "./recent_project_carousel.vue?vue&type=style&index=0&id=baaf64ea&lang=css"
script.render = render

export default script